<template>
  <v-row no-gutters>
    <v-col cols="12" v-if="isFetched">
      <v-data-table :headers="headers" v-bind="tableProps" :items="items"> </v-data-table>
    </v-col>
    <template v-else>
      <main-loader class="pt-5" />
    </template>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import MainLoader from '@/components/MainLoader';
export default {
  name: 'LayerFeaturesDataTable',
  components: {
    MainLoader,
  },
  props: {
    layerId: {
      type: [Number, String],
      required: true,
    },
    emptyWithoutFilter: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    filteredObjectsIds: {
      type: Array,
      default: () => {
        return [];
      },
    },
    layerFilter: {
      type: Object,
    },
    tableProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    layer: get('layers/layers@:layerId'),
    metadata: get('layers/metadata@:dataSource'),
    dataSource() {
      return this.layer.data_source_name;
    },
    computedAttributes() {
      if (this.metadata) {
        return this.metadata.attributes_schema.attributes;
      }
      return undefined;
    },
    idAttributeName() {
      return this.metadata && this.metadata.attributes_schema ? this.metadata.attributes_schema.id_name : '';
    },
    items() {
      return this.features.map(feature => {
        return {
          [this.idAttributeName]: feature.id,
          ...feature.properties,
        };
      });
    },
    headers() {
      const elements = this.$_flattenStructure(this.layer.form_schema.elements).map(e => {
        return {
          text: e.label,
          value: e.attribute,
          align: 'center',
        };
      });
      return elements;
    },
  },
  data: () => ({
    currentFeaturesFilter: undefined,
    features: [],
    isFetched: false,
  }),
  methods: {
    getLayerFeatures: call('layers/getLayerFeatures'),
    async init() {
      const payload = {
        layer_id: this.layerId,
        features_filter: undefined,
      };
      const idAttribute = this.metadata.attributes_use_datasource_qualified_names
        ? this.idAttributeName
        : `${this.dataSource}.${this.idAttributeName}`;
      if (this.layerFilter) {
        payload.features_filter = this.layerFilter;
      } else if (this.filteredObjectsIds.length > 0) {
        payload.features_filter = {
          $IN: {
            [idAttribute]: this.filteredObjectsIds,
          },
        };
      }
      this.currentFeaturesFilter = payload.features_filter;
      if (!payload.features_filter && this.emptyWithoutFilter) {
        this.features = [];
      } else {
        const r = await this.getLayerFeatures(payload);
        this.features = r.data.data.features.features;
      }
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .v-data-table-header th {
    white-space: nowrap;
  }
}
</style>
